import generateId from '@com/utils/generate-id'
import { ResourceCategory } from '@ps/bridge/resource/pool/type'
import _ from 'lodash'
import store from '@ps/store'
import keys from '@ps/permission/keys'
import { SceneType } from '@ps/bridge/qc/scripts/scene-config'
import { hasPermission } from '@ps/plugins/permission-manager/manager'

export const isDcoResource = (name: string): boolean => {
  const re = /^(pb_|gf_|bm_|eb_|ctat_)/
  return re.test(name)
}

/**
 * 生成图片资源的名称
 * @param uuid 资源 md5 值
 */
export const generateImageName = (uuid: string): string => {
  return `image_${uuid}`
}

export const generateVideoName = (): string => {
  return `video_${generateId()}`
}

export const generateXlzActionName = (): string => {
  return `action_name_${generateId()}`
}

/**
 * 资源类型：内部/外部
 * @param identify  1 公开；2 仅内部使用
 */
export const isInnerResource = (identify: number): boolean => {
  return identify === 2
}

// 粒子ResourceCategory.PARTICLE不能上传
export const ResourceAccepts: Record<ResourceCategory, string> = {
  [ResourceCategory.IMAGE]: '.jpg,.jpeg,.png',
  [ResourceCategory.VIDEO]: 'video/mp4',
  [ResourceCategory.AUDIO]: '.mp3',
  [ResourceCategory.DRAGON_BONE]: '.zip',
  [ResourceCategory.SEQUENCE_FRAME]: '.zip',
  [ResourceCategory.PARTICLE]: '',
}

// 权限检查
export const checkPermission = (category: string) => {
  // 检查视频、音频是否有插入权限
  const checkList = ['image', 'video', 'audio', 'bgm', 'effect']
  // 第一次加载项目时，通过 workbench.ts 中生成权限 key 时的权限控制，默认都显示
  let StaticPermission = true
  let DynamicPermission = true

  const sceneEditType = store.state.workspace.game.sceneManager.sceneEditType
  const supportGlobalVar = store.state.workspace.globalVar.supportGlobalVar

  // 动态权限，可能会在编辑器运行过程中的权限控制
  const DynamicPermissionMap = {
    globalVar: supportGlobalVar && sceneEditType !== SceneType.PLAY,
    audio: sceneEditType !== SceneType.PLAY,
    bgm: sceneEditType !== SceneType.PLAY,
  }
  if (checkList.indexOf(category) > -1) {
    // @ts-ignore
    StaticPermission = hasPermission(keys[_.camelCase(`category_${category}`)])
  }
  // @ts-ignore
  if (typeof DynamicPermissionMap[category] !== 'undefined') {
    // @ts-ignore
    DynamicPermission = DynamicPermissionMap[category]
  }
  return StaticPermission && DynamicPermission
}
